<script lang="ts">
import { ref } from "vue";

/** One shared 30-second clock for every relative timestamp on the page. */
const now = ref(Date.now());
if (typeof window !== "undefined") window.setInterval(() => (now.value = Date.now()), 30_000);
</script>

<script setup lang="ts">
import { computed } from "vue";
import { formatDateTime, relativeTime, toDate } from "@/lib/format";

/** "5 minutes ago", with the exact time on hover. */
const props = defineProps<{ value: string | number | Date | null | undefined }>();
const date = computed(() => toDate(props.value));
</script>

<template>
  <time v-if="date" :datetime="date.toISOString()" :title="formatDateTime(date)">{{ relativeTime(date, now) }}</time>
  <span v-else class="text-muted-foreground">—</span>
</template>
